import * as React from 'react';
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Popover, Typography } from '@material-ui/core';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import HelpIcon from '@material-ui/icons/Help';
import { ConfirmationNumberSharp } from '@material-ui/icons';
import { traducirLabel, traducirMessage } from '../../blocks/traductor';

interface Props {
    abierto: boolean
    label:string
    verificar: () => void
    noverificar: () => void
    cerrar: () => void
}


const ConfirmDireccion = ({ label, abierto, cerrar, verificar, noverificar }: Props) => {

   

   

    return (<>

        <Dialog
            open={abierto}
            onClose={cerrar}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{traducirMessage(24)}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
               {label} 
          </DialogContentText>
            </DialogContent>
            <DialogActions>
               
                
                <Button onClick={verificar} color="primary" autoFocus>
                    {traducirLabel(279)}
               </Button>
               <Button onClick={noverificar} color="primary">
                    {traducirLabel(189)}
                </Button>
                <Button onClick={cerrar} color="primary">
                    {traducirLabel(109)}
                </Button>
            </DialogActions>
        </Dialog>
    </>)
};

export default ConfirmDireccion;
